import * as React from 'react';
import { ITelemetryIngestionContextProps } from './TelemetryIngestionContextProvider.types';

export const TelemetryIngestionContext = React.createContext<
  ITelemetryIngestionContextProps
>({
  ariaIngestionKey: ''
});

export const TelemetryIngestionContextProvider: React.FC<
  ITelemetryIngestionContextProps
> = props => {
  const contextValue: ITelemetryIngestionContextProps = {
    ariaIngestionKey: props.ariaIngestionKey
  };
  return (
    <TelemetryIngestionContext.Provider value={contextValue}>
      {props.children}
    </TelemetryIngestionContext.Provider>
  );
};
